import { Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormStateService } from '../../services/form-state.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UniqueDomainValidatorService } from '../../services/unique-domain-validator.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-organization-info-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  templateUrl: './organization-info-form.component.html',
  styleUrl: './organization-info-form.component.scss'
})
export class OrganizationInfoFormComponent {
  signUpForm!: FormGroup;
  organizationInfoForm!: FormGroup;
  adminInfoForm!: FormGroup;
  isChecking$;
  hidePassword = true;

  industries = [
    'Professional Association',
    'Trade Association',
    'Non-Profit/Charity',
    'Religious Organization',
    'Alumni Association',
    'Fraternity/Sorority',
    'Social Club',
    'Sports & Recreation Club',
    'Fitness/Wellness Club',
    'Country Club/Private Club',
    'Homeowners Association (HOA)',
    'Co-op/Condo Association',
    'Veterans Organization',
    'Service Organization (Rotary, Lions, etc.)',
    'Chamber of Commerce',
    'Trade Union/Labor Organization',
    'Youth Organization',
    'Arts & Cultural Organization',
    'Environmental/Conservation Group',
    'Political Organization/Party',
    'Community Group',
    'Networking Group',
    'Membership Co-working Space',
    'Other'
  ];
  
  constructor(private readonly formStateService: FormStateService, private readonly domainValidator: UniqueDomainValidatorService) {
    this.signUpForm = this.formStateService.getForm();
    this.organizationInfoForm = this.signUpForm.get('organizationInformation') as FormGroup;
    this.adminInfoForm = this.signUpForm.get('adminInformation') as FormGroup;
    this.isChecking$ = this.domainValidator.isChecking$;
  }

  onOrganizationNameChange() {
    const nameControl = this.organizationInfoForm.get('name');
    const domainControl = this.organizationInfoForm.get('domain');
    
    // Only auto-generate if domain is empty or was auto-generated
    if (nameControl?.value && (!domainControl?.value || !domainControl.dirty)) {
      const suggestedDomain = this.generateDomainFromName(nameControl.value);
      domainControl?.setValue(suggestedDomain);
      // Mark as pristine so user knows it's auto-generated
      domainControl?.markAsPristine();
    }
  }

  private generateDomainFromName(name: string): string {
    return name
      .toLowerCase()
      .replaceAll(/[^a-z0-9\s-]/g, '') // Remove special characters
      .replaceAll(/\s+/g, '-') // Replace spaces with hyphens
      .replaceAll(/-+/g, '-') // Replace multiple hyphens with single
      .replaceAll(/(^-|-$)/g, '') // Remove leading/trailing hyphens
      .substring(0, 50); // Limit to 50 characters
  }
}
